import { validateShipmentListSearch } from '#/entities/shipment'
import type { ShipmentListSearch } from '#/entities/shipment'

// The leads route shares the canonical shipment-list search validator
// (owner/tab/date filters preserved across navigation). Kept as named
// re-exports so existing route/barrel imports stay stable.
export type LeadsSearch = ShipmentListSearch
export const validateLeadsSearch = validateShipmentListSearch
